var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"ma-0 pa-0 mw-100"},[_c('v-container',{staticClass:"text-uppercase ma-0 pa-0 mw-100",class:`text-${_vm.$vuetify.breakpoint.name}-h6`,style:(_vm.styleObject())},[_vm._v(_vm._s(_vm.text))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }